const settingsLanguage = {
  en: {
    pageTitle: "More",
    pageSubtitle: "Manage your dairy settings and preferences",

    // Group titles
    generalSettings: "General", //General Settings
    customerManagementGroup: "Customer Management",
    masterManagement: "Master Management",
    salesExpensesGroup: "Manage Sales & Expenses",
    userManagementGroup: "User Management",

    // Language section
    languageSectionTitle: "Language",
    languageSelectLabel: "Select Language",
    languageEnglish: "English",
    languageMarathi: "Marathi",

    // Profile Settings
    profileSettings: "Profile Settings",
    profileSettingsDesc: "Update your account information",

    // Customer Management
    customerManagementTitle: "Customer Management",
    addCustomer: "Add Customer",
    addCustomerDesc: "Create a new customer record",
    editDeleteCustomer: "Edit & Delete Customer",
    editDeleteCustomerDesc: "Manage existing customer records",
    customerLeave: "Customer Leave",
    customerLeaveDesc: "Set customer leave dates (auto 0 milk)",
    customerName: "Customer Name",
    whatsappNo: "WhatsApp No",
    milkType: "Milk Type",
    actions: "Actions",
    milkTypeCow: "Cow",
    milkTypeBuffalo: "Buffalo",
    milkTypeBoth: "Both",
    useMasterRate: "Use Master Rate",
    cowRate: "Cow Rate (₹/Ltr)",
    cowDefaultLiters: "Cow Default Liters",
    buffaloRate: "Buffalo Rate (₹/Ltr)",
    buffaloDefaultLiters: "Buffalo Default Liters",
    saveCustomer: "Save Customer",
    updateCustomer: "Update Customer",
    cancel: "Cancel",
    delete: "Delete",
    pendingSuffix: "pending",
    editAndDelete: "Edit and Delete",

    // Customer Leave Page
    startDate: "Start Date",
    endDate: "End Date",
    reasonOptional: "Reason (optional)",
    reasonPlaceholder: "e.g. Family function, vacation...",
    updateLeave: "Update Leave",
    addLeave: "Add Leave",
    activeLeaves: "Active Leaves",
    noLeavesYet: "No leaves added yet",
    editLeaveInstruction: "Editing leave - modify the dates/reason below",
    customerColumn: "Customer",
    startDateColumn: "Start Date",
    endDateColumn: "End Date",
    reasonColumn: "Reason",
    leaveAdded: "Leave added successfully",
    leaveUpdated: "Leave updated successfully",
    leaveDeleted: "Leave deleted successfully",

    // Customer List Page
    customerListPageTitle: "Customer List",
    searchNamePhonePlaceholder: "Search by name or phone...",
    nameColumn: "Name",
    whatsappColumn: "WhatsApp",
    noCustomersMatchSearch: "No customers found matching your search",
    noCustomersYet: "No customers added yet",
    showingCustomers: "Showing {count} of {total} customers",

    // Add/Edit Customer Page
    back: "Back",
    enterCustomerName: "Enter customer name",
    whatsappPlaceholder: "e.g., 9876543210",
    reset: "Reset",
    addCustomerPageTitle: "Add Customer",
    editCustomerPageTitle: "Edit Customer",

    // Dairy Info Page
    enterDairyName: "Enter dairy name",
    dairyNameRequired: "Dairy name is required",
    dairySaved: "Dairy information saved successfully!",

    // Milk Rate Page
    enterCowRate: "Enter cow milk rate",
    enterBuffaloRate: "Enter buffalo milk rate",
    ratesUpdated: "Milk rates updated successfully!",
    ratesUpdateFailed: "Failed to update rates.",
    ratesUpdateError: "Error updating rates.",

    // Allowance Page
    allowancesSaveError: "Error saving allowances.",

    // Master Management
    dairyInformation: "Dairy Information",
    dairyInfoDesc: "Manage dairy name, logo, and payment QR",
    dairyName: "Dairy Name",
    dairyLogo: "Dairy Logo",
    paymentQrImage: "Payment QR Image",
    saveDairyInfo: "Save Dairy Info",

    milkRateMaster: "Milk Rate Master",
    milkRateDesc: "Set cow and buffalo milk rates",
    cowMilkRateMaster: "Cow Milk Rate (₹/Ltr)",
    buffaloMilkRateMaster: "Buffalo Milk Rate (₹/Ltr)",
    saveRates: "Save Rates",

    expensesMaster: "Expenses Master",
    expensesDesc: "Manage purchase milk and other expenses",

    salesMaster: "Sales Master",
    salesDesc: "Manage other sales entries",

    allowanceMaster: "Allowance Master",
    allowanceDesc: "Set transport, packing, and other allowances",

    // Purchase Milk Entry
    purchaseMilkEntry: "Purchase Milk Entry",
    purchaseMilkType: "Milk Type",
    purchaseLiterQty: "Purchase Liter Qty",
    purchaseRate: "Purchase Rate (₹/Ltr)",
    savePurchaseEntry: "Save Purchase Entry",

    // Allowance Section
    allowanceSectionTitle: "Allowance",
    transportAllowance: "Transport Allowance (₹)",
    packingAllowance: "Packing Allowance (₹)",
    otherAllowance: "Other Allowance (₹)",
    saveAllowances: "Save Allowances",
    allowancesSavedSuccess: "Allowances saved successfully!",
    allowancesSaveFailed: "Failed to save allowances.",
    success: "Success",
    error: "Error",
    saving: "Saving...",

    // User Management (Admin Only)
    userManagementTitle: "User Management",
    userManagementDesc: "Manage users, passwords, and subscriptions",
    userManagementDescription:
      "Manage all user accounts, passwords, and subscriptions from one place.",
    viewAllUsers: "View all users",
    activateDeactivateUsers: "Activate/Deactivate users",
    resetPasswords: "Reset user passwords",
    manageSubscriptions: "Manage subscriptions",
    openUserManagement: "Open User Management",

    // Employee Management
    employeeManagement: "Employee Management",
    employeeManagementDesc: "Manage your employees and their permissions",
    customerAssignment: "Customer Assignment",
    addEmployee: "Add Employee",
    searchEmployees: "Search employees...",
    editEmployee: "Edit Employee",
    addNewEmployee: "Add New Employee",
    username: "Username",
    enterUsername: "Enter username",
    password: "Password",
    enterPassword: "Enter password (min 4 chars)",
    create: "Create",
    update: "Update",
    id: "ID",
    status: "Status",
    customers: "Customers",
    modules: "Modules",
    created: "Created",
    active: "Active",
    inactive: "Inactive",
    assignPermissions: "Assign Permissions",
    assignCustomers: "Assign Customers",
    edit: "Edit",
    deactivate: "Deactivate",
    activate: "Activate",
    noEmployeesFound: "No employees found",
    modulePermissions: "Module Permissions",
    savePermissions: "Save Permissions",
    assignedCustomers: "Assigned Customers",
    noCustomersAssigned: "No customers assigned",
    searchCustomers: "Search customers...",
    noUnassignedCustomers: "No unassigned customers available",
    available: "Available",
    assigned: "Assigned",
    assign: "Assign",
    remove: "Remove",
    noMatchingAssigned: "No matching assigned customers",
    groupReportBilling: "Report & Billing",
    groupManage: "Manage",

    // Logout
    logoutSectionTitle: "Account",
    logoutButton: "Logout",
    logoutConfirmMessage: "Are you sure you want to logout?",
  },
  mr: {
    pageTitle: "अधिक",
    pageSubtitle: "तुमच्या डेअरी सेटिंग्ज आणि प्राधान्ये व्यवस्थापित करा",

    // Group titles
    generalSettings: "सामान्य सेटिंग्ज",
    customerManagementGroup: "ग्राहक मॅनेजमेंट",
    masterManagement: "मास्टर मॅनेजमेंट",
    salesExpensesGroup: "विक्री आणि खर्च व्यवस्थापित करा",
    userManagementGroup: "वापरकर्ता मॅनेजमेंट",

    // Language section
    languageSectionTitle: "भाषा",
    languageSelectLabel: "भाषा निवडा",
    languageEnglish: "इंग्रजी",
    languageMarathi: "मराठी",

    // Profile Settings
    profileSettings: "प्रोफाइल सेटिंग्ज",
    profileSettingsDesc: "तुमची खाती माहिती अपडेट करा",

    // Customer Management
    customerManagementTitle: "ग्राहक मॅनेजमेंट",
    addCustomer: "ग्राहक जोडा",
    addCustomerDesc: "नवीन ग्राहक रेकॉर्ड तयार करा",
    editDeleteCustomer: "Edit आणि काढून टाका",
    editDeleteCustomerDesc: "विद्यमान ग्राहक रेकॉर्ड व्यवस्थापित करा",
    customerLeave: "ग्राहक रजा",
    customerLeaveDesc: "ग्राहक रजा तारखा सेट करा (आपोआप ० दूध)",
    customerName: "ग्राहक नाव",
    whatsappNo: "व्हॉट्सॲप क्रमांक",
    milkType: "दूध प्रकार",
    actions: "क्रिया",
    milkTypeCow: "गायीचे",
    milkTypeBuffalo: "म्हशीचे",
    milkTypeBoth: "दोन्ही",
    useMasterRate: "मास्टर रेट वापरा",
    cowRate: "गायीचे दर (₹/लिटर)",
    cowDefaultLiters: "गायीचे डीफॉल्ट लिटर",
    buffaloRate: "म्हशीचे दर (₹/लिटर)",
    buffaloDefaultLiters: "म्हशीचे डीफॉल्ट लिटर",
    saveCustomer: "ग्राहक सेव्ह करा",
    updateCustomer: "ग्राहक अपडेट करा",
    cancel: "रद्द करा",
    delete: "काढून टाका",
    pendingSuffix: "बाकी",
    editAndDelete: "Edit आणि काढून टाका",

    // Customer Leave Page
    startDate: "सुरुवात तारीख",
    endDate: "शेवट तारीख",
    reasonOptional: "कारण (optional)",
    reasonPlaceholder: "उदा. कौटुंबिक कार्यक्रम, सुट्टी...",
    updateLeave: "रजा अपडेट करा",
    addLeave: "रजा जोडा",
    activeLeaves: "सक्रिय रजा",
    noLeavesYet: "अजून रजा जोडल्या नाहीत",
    editLeaveInstruction: "रजा एडिट करत आहे - खाली तारखा/कारण बदला",
    customerColumn: "ग्राहक",
    startDateColumn: "सुरुवात तारीख",
    endDateColumn: "शेवट तारीख",
    reasonColumn: "कारण",
    leaveAdded: "रजा यशस्वीरित्या जोडली",
    leaveUpdated: "रजा यशस्वीरित्या अपडेट केली",
    leaveDeleted: "रजा यशस्वीरित्या हटवली",

    // Customer List Page
    customerListPageTitle: "ग्राहक यादी",
    searchNamePhonePlaceholder: "नाव किंवा फोनने शोधा...",
    nameColumn: "नाव",
    whatsappColumn: "WhatsApp",
    noCustomersMatchSearch: "तुमच्या शोधाशी जुळणारे ग्राहक आढळले नाहीत",
    noCustomersYet: "अजून ग्राहक जोडले नाहीत",
    showingCustomers: "{count} पैकी {total} ग्राहक दाखवत आहे",

    // Add/Edit Customer Page
    back: "मागे",
    enterCustomerName: "ग्राहकाचे नाव प्रविष्ट करा",
    whatsappPlaceholder: "उदा., 9876543210",
    reset: "रीसेट",
    addCustomerPageTitle: "ग्राहक जोडा",
    editCustomerPageTitle: "ग्राहक एडिट करा",

    // Dairy Info Page
    enterDairyName: "डेअरीचे नाव प्रविष्ट करा",
    dairyNameRequired: "डेअरीचे नाव आवश्यक आहे",
    dairySaved: "डेअरी माहिती यशस्वीरित्या जतन केली!",

    // Milk Rate Page
    enterCowRate: "गायीचे दूध दर प्रविष्ट करा",
    enterBuffaloRate: "म्हशीचे दूध दर प्रविष्ट करा",
    ratesUpdated: "दूध दर यशस्वीरित्या अपडेट केले!",
    ratesUpdateFailed: "दर अपडेट करण्यात अयशस्वी.",
    ratesUpdateError: "दर अपडेट करताना त्रुटी.",

    // Allowance Page
    allowancesSaveError: "भत्ते सेव्ह करताना त्रुटी.",

    // Master Management
    dairyInformation: "डेअरी माहिती",
    dairyInfoDesc: "डेअरी नाव, लोगो आणि पेमेंट QR व्यवस्थापित करा",
    dairyName: "डेअरीचे नाव",
    dairyLogo: "डेअरी लोगो",
    paymentQrImage: "पेमेंट QR प्रतिमा",
    saveDairyInfo: "डेअरी माहिती सेव्ह करा",

    milkRateMaster: "दूध दर मास्टर",
    milkRateDesc: "गाय आणि म्हैस दूध दर सेट करा",
    cowMilkRateMaster: "गायीचे दूध दर (₹/लिटर)",
    buffaloMilkRateMaster: "म्हशीचे दूध दर (₹/लिटर)",
    saveRates: "दर सेव्ह करा",

    expensesMaster: "खर्च मास्टर",
    expensesDesc: "खरेदी दूध आणि इतर खर्च व्यवस्थापित करा",

    salesMaster: "विक्री मास्टर",
    salesDesc: "इतर विक्री नोंदी व्यवस्थापित करा",

    allowanceMaster: "भत्ता मास्टर",
    allowanceDesc: "वाहतूक, पॅकिंग आणि इतर भत्ते सेट करा",

    // Purchase Milk Entry
    purchaseMilkEntry: "दूध खरेदी नोंद",
    purchaseMilkType: "दूध प्रकार",
    purchaseLiterQty: "खरेदी लिटर प्रमाण",
    purchaseRate: "खरेदी दर (₹/लिटर)",
    savePurchaseEntry: "खरेदी नोंद सेव्ह करा",

    // Allowance Section
    allowanceSectionTitle: "भत्ता",
    transportAllowance: "वाहतूक भत्ता (₹)",
    packingAllowance: "पॅकिंग भत्ता (₹)",
    otherAllowance: "इतर भत्ता (₹)",
    saveAllowances: "भत्ते सेव्ह करा",
    allowancesSavedSuccess: "भत्ते यशस्वीरित्या जतन केले!",
    allowancesSaveFailed: "भत्ते जतन करण्यात अयशस्वी.",
    success: "यशस्वी",
    error: "त्रुटी",
    saving: "जतन करत आहे...",

    // User Management (Admin Only)
    userManagementTitle: "वापरकर्ता मॅनेजमेंट",
    userManagementDesc: "वापरकर्ते, पासवर्ड आणि सदस्यता व्यवस्थापित करा",
    userManagementDescription:
      "एका ठिकाणाहून सर्व वापरकर्ता खाती, पासवर्ड आणि सदस्यता व्यवस्थापित करा.",
    viewAllUsers: "सर्व वापरकर्ते पहा",
    activateDeactivateUsers: "वापरकर्ते सक्रिय/निष्क्रिय करा",
    resetPasswords: "वापरकर्ता पासवर्ड रीसेट करा",
    manageSubscriptions: "सदस्यता व्यवस्थापित करा",
    openUserManagement: "वापरकर्ता मॅनेजमेंट उघडा",

    // Employee Management
    employeeManagement: "कर्मचारी मॅनेजमेंट",
    employeeManagementDesc: "तुमचे कर्मचारी आणि त्यांची परवानगी व्यवस्थापित करा",
    customerAssignment: "ग्राहक नियुक्ती",
    addEmployee: "कर्मचारी जोडा",
    searchEmployees: "कर्मचारी शोधा...",
    editEmployee: "कर्मचारी संपादित करा",
    addNewEmployee: "नवीन कर्मचारी जोडा",
    username: "वापरकर्तानाव",
    enterUsername: "वापरकर्तानाव प्रविष्ट करा",
    password: "पासवर्ड",
    enterPassword: "पासवर्ड प्रविष्ट करा (किमान 4 अक्षरे)",
    create: "तयार करा",
    update: "अपडेट करा",
    id: "क्र",
    status: "स्थिती",
    customers: "ग्राहक",
    modules: "मॉड्यूल्स",
    created: "तयार केले",
    active: "सक्रिय",
    inactive: "निष्क्रिय",
    assignPermissions: "परवानगी नियुक्त करा",
    assignCustomers: "ग्राहक नियुक्त करा",
    edit: "संपादित करा",
    deactivate: "निष्क्रिय करा",
    activate: "सक्रिय करा",
    noEmployeesFound: "कोणतेही कर्मचारी आढळले नाहीत",
    modulePermissions: "मॉड्यूल परवानग्या",
    savePermissions: "परवानग्या सेव्ह करा",
    assignedCustomers: "नियुक्त ग्राहक",
    noCustomersAssigned: "कोणतेही ग्राहक नियुक्त नाहीत",
    searchCustomers: "ग्राहक शोधा...",
    noUnassignedCustomers: "कोणतेही अनियुक्त ग्राहक उपलब्ध नाहीत",
    available: "उपलब्ध",
    assigned: "नियुक्त",
    assign: "नियुक्त करा",
    remove: "काढा",
    noMatchingAssigned: "जुळणारे नियुक्त ग्राहक नाहीत",
    groupReportBilling: "अहवाल आणि बिलिंग",
    groupManage: "व्यवस्थापित करा",

    // Logout
    logoutSectionTitle: "खाते",
    logoutButton: "लॉगआउट",
    logoutConfirmMessage: "तुम्हाला खात्री आहे की तुम्ही लॉगआउट करू इच्छिता?",
  },
};

export default settingsLanguage;
